<template>
    <div>
        <div class="flex items-end justify-between mb-2" v-if="label">
            <label class="flex items-center text-sm space-x-1 text-gray-600">
                <span class="font-medium text-gray-700" v-text="label" />
                <slot name="label-icon" />
            </label>
            <slot name="after-label">
                <span class="text-xs text-gray-400" v-text="hint" v-if="hint" />
            </slot>
        </div>
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'ApexoInputGroup',

        props: {
            label: {
                type: String,
                default: '',
            },
            hint: {
                type: String,
                default: '',
            },
        },
    };
</script>
